import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, unref as _unref, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/default-avater.png'
import _imports_1 from '../assets/img/no-record.png'


const _withScopeId = n => (_pushScopeId("data-v-69ca6172"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "post-wrap"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 2,
  src: _imports_0,
  alt: ""
}
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "text-wrap" }
const _hoisted_8 = { class: "text-info" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 0,
  class: "bg-item run"
}
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_1 + "\" alt=\"\" data-v-69ca6172><div class=\"run-info\" data-v-69ca6172><div class=\"title\" data-v-69ca6172>跑步距离·3.0KM</div><div class=\"des\" data-v-69ca6172><div class=\"des-item first\" data-v-69ca6172><p data-v-69ca6172>用时</p><p data-v-69ca6172>30&#39;</p></div><div class=\"des-item\" data-v-69ca6172><p data-v-69ca6172>配速</p><p data-v-69ca6172>9&#39;22&#39;</p></div></div></div>", 2)
const _hoisted_14 = [
  _hoisted_12
]
const _hoisted_15 = {
  key: 1,
  class: "bg-item run"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "run-info" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = { class: "des" }
const _hoisted_20 = { class: "des-item first" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "用时", -1))
const _hoisted_22 = { class: "des-item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "配速", -1))
const _hoisted_24 = {
  key: 2,
  class: "bg-item book"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "book-info" }
const _hoisted_27 = {
  key: 3,
  class: "bg-item like"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "like-info" }
const _hoisted_30 = { class: "user-name" }
const _hoisted_31 = { class: "user-title" }
const _hoisted_32 = {
  key: 4,
  class: "bg-item run-outside"
}
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "run-out-info" }
const _hoisted_35 = { class: "run-out-des" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "des-title" }, "跑步距离", -1))
const _hoisted_37 = { class: "des-des" }
const _hoisted_38 = { class: "run-out-des" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "des-title" }, "用时", -1))
const _hoisted_40 = { class: "des-des" }
const _hoisted_41 = { class: "run-out-des" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "des-title" }, "配速", -1))
const _hoisted_43 = { class: "des-des" }
const _hoisted_44 = { class: "run-out-des" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "des-title" }, "步数", -1))
const _hoisted_46 = { class: "des-des" }
const _hoisted_47 = {
  key: 0,
  class: "post-footer"
}

import { computed, onMounted, ref, nextTick } from 'vue';
import ImgBox from '../components/ImgBox.vue';
import { timeTransform, format } from '@/lib';
interface EmitsType {
  (e: 'download'): void;
}

export default /*#__PURE__*/_defineComponent({
  props: {
  detail: {
    type: Object,
    default: {}
  },
  isDelete: {
    type: Boolean,
    default: false
  }
},
  emits: ["download"],
  setup(__props, { emit }: { emit: ({
  (e: 'download'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props

const showNull = ref(false);

const showDetailBtn = ref(false);
const splitConent = ref('');
const formatDate = computed(() => {
  const newstr = format(props.detail.pubTime) || '';
  const result = timeTransform(newstr);
  showDetailBtnFun();
  return result;
});

// 文字溢出 显示全文按钮
const showDetailBtnFun = () => {
  nextTick(() => {
    if (props.detail.content.length > 110) {
      splitConent.value = props.detail.content.substring(0, 110) + '...' + '<span class="all-tips" style="color: #004E97">全文</span>';
      showDetailBtn.value = true;
    } else {
      showDetailBtn.value = false;
    }
  });
};


const download = () => {
  emit('download');
};

// 将秒转成对应格式
const formatSeconds = (value: any) => {
  var secondTime = parseInt(value); // 秒
  var minuteTime = 0; // 分
  var hourTime = 0; // 小时
  if (secondTime > 60) {
    minuteTime = parseInt(secondTime / 60);
    secondTime = parseInt(secondTime % 60);
    if (minuteTime > 60) {
      hourTime = parseInt(minuteTime / 60);
      minuteTime = parseInt(minuteTime % 60);
    }
  }
  var result = '' + parseInt(secondTime) + '"';
  if (hourTime > 0) {
    minuteTime += parseInt(hourTime) * 60;
  }
  if (minuteTime > 0) {
    result = '' + parseInt(minuteTime) + "'" + result;
  }

  console.log('result', result);
  return result;
};


return (_ctx: any,_cache: any) => {
  return ((__props.detail && __props.detail.articleId) || __props.isDelete)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (__props.isDelete)
            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
            : (__props.detail.userInfo.userLogo)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: __props.detail.userInfo.userLogo,
                  alt: ""
                }, null, 8, _hoisted_4))
              : (_openBlock(), _createElementBlock("img", _hoisted_5)),
          _createElementVNode("p", null, _toDisplayString(__props.isDelete ? '某用户' : __props.detail.userInfo.userName), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (showDetailBtn.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "detail-info",
                    innerHTML: splitConent.value
                  }, null, 8, _hoisted_9))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "detail-info",
                    innerHTML: __props.detail?.content
                  }, null, 8, _hoisted_10))
            ])
          ]),
          (__props.detail.imageList)
            ? (_openBlock(), _createBlock(ImgBox, {
                key: 0,
                class: "img-list",
                picUrl: __props.detail?.imageList,
                noPreview: true,
                onDownload: download
              }, null, 8, ["picUrl"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            (__props.isDelete)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
              : _createCommentVNode("", true),
            (__props.detail.type === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("img", {
                    src: __props.detail.runInfo.runImageUrl,
                    alt: ""
                  }, null, 8, _hoisted_16),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, "跑步距离·" + _toDisplayString(__props.detail.runInfo.runTotal) + "KM", 1),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("p", null, _toDisplayString(formatSeconds(__props.detail.runInfo.runTime)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("p", null, _toDisplayString(__props.detail.runInfo.runSpeed), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (__props.detail.type === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("img", {
                    src: __props.detail.bookInfo.bookCover,
                    alt: ""
                  }, null, 8, _hoisted_25),
                  _createElementVNode("div", _hoisted_26, _toDisplayString(__props.detail.bookInfo.bookTitle), 1)
                ]))
              : _createCommentVNode("", true),
            (__props.detail.type === 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("img", {
                    class: "like-logo",
                    src: __props.detail?.likeOrgUserInfo?.userLogo,
                    alt: ""
                  }, null, 8, _hoisted_28),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("p", _hoisted_30, _toDisplayString(__props.detail?.likeOrgUserInfo?.userName), 1),
                    _createElementVNode("p", _hoisted_31, _toDisplayString(__props.detail?.likeOrgUserInfo?.departmentInfo), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (__props.detail.type === 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("img", {
                    class: "run-bg",
                    src: __props.detail.runOutdoorsInfo.runImg,
                    alt: ""
                  }, null, 8, _hoisted_33),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("p", _hoisted_37, _toDisplayString(__props.detail.runOutdoorsInfo.distance) + "KM", 1)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("p", _hoisted_40, _toDisplayString(__props.detail.runOutdoorsInfo.runTime), 1)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("p", _hoisted_43, _toDisplayString(__props.detail.runOutdoorsInfo.spendDesc), 1)
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _createElementVNode("p", _hoisted_46, _toDisplayString(__props.detail.runOutdoorsInfo.totalSteps), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (__props.detail.pubTime)
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
              _createElementVNode("p", null, "发表于" + _toDisplayString(_unref(formatDate)), 1)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})